import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { MouseEvent } from 'react';
import { ReactComponent as BearishIcon } from '../../../assets/svg/bearish_zoomout.svg';
import { ReactComponent as BullishIcon } from '../../../assets/svg/bullish_zoomout.svg';
import { ReactComponent as NeutralIcon } from '../../../assets/svg/sentiment_minus.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { SentimentType } from '../../../modules/trading/states/priceAlertsAtom';
import { NbTooltip } from '../tooltip/Tooltip';
import classes from './SentimentSelector.module.scss';

export type NbSentimentSelectorProps = {
  sentiment: SentimentType;
  onChange: (sentiment: SentimentType) => void;
};

export const NbSentimentSelector = ({ sentiment, onChange }: NbSentimentSelectorProps) => {
  const { translation } = useLocale();

  const handleChange = (_event: MouseEvent<HTMLElement>, newSentiment: string) => {
    if (newSentiment) {
      onChange(newSentiment as SentimentType);
    }
  };

  return (
    <div className={classes.selector}>
      <ToggleButtonGroup
        color="primary"
        value={sentiment}
        exclusive
        onChange={handleChange}
      >
        <ToggleButton value={SentimentType.Bear}>
          <NbTooltip
            title={translation.priceAlerts.modal.bearishTooltip}
            placement={'top'}
          >
            <BearishIcon />
          </NbTooltip>
        </ToggleButton>

        <ToggleButton value={SentimentType.Neut}>
          <NbTooltip
            title={translation.priceAlerts.modal.neutralTooltip}
            placement={'top'}
          >
            <NeutralIcon />
          </NbTooltip>
        </ToggleButton>

        <ToggleButton value={SentimentType.Bull}>
          <NbTooltip
            title={translation.priceAlerts.modal.bullishTooltip}
            placement={'top'}
          >
            <BullishIcon />
          </NbTooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
